import { ScheduleTourApi } from 'services/Api/schedule/ScheduleTourApi';
import { AddPlaceDemandScheduleWithPaymentRequest } from '../../_domain/dto/ReservePlaceSchedule/IAddPlaceDemandScheduleWithPaymentRequest';

export const PostReserveTourScheduleUseCase = async (request: AddPlaceDemandScheduleWithPaymentRequest) => {
    const scheduleTourApi = ScheduleTourApi();
    await scheduleTourApi.postReserveTourWithPayment(request);
    return
}
